import React from 'react'
import Icon from 'components/Icon'
import styles from './OverviewV2.module.scss'
import { OverviewV2MetaItem as OverviewV2MetaItemType } from './types'
import { OverflowText } from '../../uikit/utils/overflowText'

interface OverviewV2MetaItemProps {
  item: OverviewV2MetaItemType
}
export const OverviewV2MetaItem = ({ item }: OverviewV2MetaItemProps) => {
  const { icon, label, value } = item

  return (
    <div className={styles.metaItem}>
      <div className={styles.metaLabel}>
        <span className={styles.label}>
          {icon ? (
            typeof icon === 'string' ? (
              <Icon name={icon} size='small' className={styles.metaIcon} />
            ) : (
              icon
            )
          ) : null}
          {label ? `${label}:` : ''}
        </span>
        <span className={styles.value}>{typeof value === 'string' ? <OverflowText text={value} /> : value}</span>
      </div>
    </div>
  )
}
